import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SettingsControls } from "@/components/layout/SettingsControls.tsx";
import { Button } from "@/components/ui/button.tsx";
import { useUserAuth } from "@/hooks/useUserAuth.ts";

export function Navbar() {
  const { t } = useTranslation();
  const { isAuthenticated, loading, signOut, user } = useUserAuth();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Failed to sign out:", error);
    }
  };

  return (
    <nav
      aria-label="Main navigation"
      className="sticky top-0 z-50 w-full border-b-4 border-foreground/20 bg-black text-white dither-bg"
    >
      <div className="flex h-16 w-full items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="font-pixel text-sm uppercase tracking-wide text-white">
            <span className="text-accent group-hover:crt-glow transition-all">
              {t("landing.hero.titleLine1")}
            </span>
            <span className="ml-1">{t("landing.hero.titleLine2")}</span>
          </span>
        </Link>

        <div className="flex items-center gap-2">
          <Button asChild variant="ghost" size="sm" className="text-white hover:text-white">
            <Link to="/catalog">{t("catalog.nav")}</Link>
          </Button>

          {loading ? null : isAuthenticated
            ? (
              <>
                <span className="hidden md:inline text-xs text-white/70 max-w-36 truncate">
                  {user?.email}
                </span>
                <Button
                  variant="outline"
                  size="sm"
                  className="text-white border-white/30 bg-white/10 hover:bg-white/20"
                  onClick={handleSignOut}
                >
                  {t("userAuth.signOut")}
                </Button>
              </>
            )
            : (
              <Button
                asChild
                size="sm"
                className="text-white border-white/30 bg-white/10 hover:bg-white/20"
              >
                <Link to="/login">{t("userAuth.signIn")}</Link>
              </Button>
            )}

          <SettingsControls className="text-white [&_button]:text-white [&_button]:border-white/30 [&_button]:bg-white/10 [&_button:hover]:bg-white/20 [&_button:hover]:border-white/60 [&_button:hover]:text-white" />
        </div>
      </div>
    </nav>
  );
}
